var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 70,
    viewBox: "0 0 65 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001c33",
    d: "M.76 16.09c0-5.523 4.477-10 10-10h43.913c5.523 0 10 4.477 10 10v43.913c0 5.523-4.477 10-10 10H10.76c-5.523 0-10-4.477-10-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001c33",
    d: "M17.5 3.35a2 2 0 012-2h1.326a2 2 0 012 2v7a2 2 0 01-2 2H19.5a2 2 0 01-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M17.5 3.35a2 2 0 012-2h1.326a2 2 0 012 2v7a2 2 0 01-2 2H19.5a2 2 0 01-2-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001c33",
    d: "M44.5 3.35a2 2 0 012-2h1.326a2 2 0 012 2v7a2 2 0 01-2 2H46.5a2 2 0 01-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M44.5 3.35a2 2 0 012-2h1.326a2 2 0 012 2v7a2 2 0 01-2 2H46.5a2 2 0 01-2-2z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NSIgaGVpZ2h0PSI3MCIgdmlld0JveD0iMCAwIDY1IDcwIj48Zz48Zz48cGF0aCBmaWxsPSIjMDAxYzMzIiBkPSJNLjc2IDE2LjA5YzAtNS41MjMgNC40NzctMTAgMTAtMTBoNDMuOTEzYzUuNTIzIDAgMTAgNC40NzcgMTAgMTB2NDMuOTEzYzAgNS41MjMtNC40NzcgMTAtMTAgMTBIMTAuNzZjLTUuNTIzIDAtMTAtNC40NzctMTAtMTB6Ii8+PC9nPjxnPjxwYXRoIGZpbGw9IiMwMDFjMzMiIGQ9Ik0xNy41IDMuMzVhMiAyIDAgMCAxIDItMmgxLjMyNmEyIDIgMCAwIDEgMiAydjdhMiAyIDAgMCAxLTIgMkgxOS41YTIgMiAwIDAgMS0yLTJ6Ii8+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTE3LjUgMy4zNWEyIDIgMCAwIDEgMi0yaDEuMzI2YTIgMiAwIDAgMSAyIDJ2N2EyIDIgMCAwIDEtMiAySDE5LjVhMiAyIDAgMCAxLTItMnoiLz48L2c+PGc+PHBhdGggZmlsbD0iIzAwMWMzMyIgZD0iTTQ0LjUgMy4zNWEyIDIgMCAwIDEgMi0yaDEuMzI2YTIgMiAwIDAgMSAyIDJ2N2EyIDIgMCAwIDEtMiAySDQ2LjVhMiAyIDAgMCAxLTItMnoiLz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1taXRlcmxpbWl0PSIyMCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNDQuNSAzLjM1YTIgMiAwIDAgMSAyLTJoMS4zMjZhMiAyIDAgMCAxIDIgMnY3YTIgMiAwIDAgMS0yIDJINDYuNWEyIDIgMCAwIDEtMi0yeiIvPjwvZz48L2c+PC9zdmc+";
export { SvgCalendar as ReactComponent };